let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("erKNi")).then(() => parcelRequire('1a3n4'));